// ProjectHeader.js
import React from "react";
import PropTypes from "prop-types";
import "./ProjectHeaderComponent.css"; // Assuming you have a separate CSS file for styling

const ProjectHeaderComponent = ({ backgroundImage, type, title }) => {
  return (
    <header
      className="entry-header"
      style={{ backgroundImage: `url("${backgroundImage}")` }}
    >
      <div className="content">
        <div className="type">{type}:</div>
        <h1 className="entry-title">{title}</h1>
      </div>
      <div className="scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>
    </header>
  );
}

ProjectHeaderComponent.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default ProjectHeaderComponent;